import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Container = styled.article`
  margin: 5px;
  width: 300px;

  @media only screen and (max-width: 768px) {
    width: 150px;
    font-size: 14px;
  }

  a {
    text-decoration: none;
    color: black;
  }

  &:hover {
    cursor: pointer;
  }

  img {
    height: 300px;
    width: 100%;
    object-fit: cover;
    border-radius: 5px 5px 0 0;

    @media only screen and (max-width: 768px) {
      height: 150px;
    }
  }
`;
const Info = styled.div`
  padding: 5px 10px 10px 10px;

  @media only screen and (max-width: 768px) {
    padding: 0 10px;
    height: 70px;
  }

  h3 {
    font-weight: 300;
  }

  span {
    font-weight: 500;
  }
`;

export default function Product(item) {
  const { img, title, price } = item;

  return (
    <Container>
      <Link to={`/products/${item._id}`}>
        <img src={img} alt="" />
        <Info className="info">
          <h3>{title}</h3>
          <span>£{price}.00</span>
        </Info>
      </Link>
    </Container>
  );
}
